
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { usePublicStatistics } from 'PortalDir/modules/Main/components/Statistics/composables/usePublicStatistics';
import DigitCounter from 'SharedComponents/ui/DigitCounter.vue';
import { useAppStore } from 'stores/app';

export default defineComponent({
  name: 'UserList',
  components: { DigitCounter },

  setup() {
    const appStore = useAppStore();
    const userList = computed(() => {
      return appStore.userPublicList;
    });
    const isSsr = computed(() => {
      return appStore.isMainSsrLoad;
    });

    const { getUserList } = usePublicStatistics();
    const { isMobile } = useDeviceSize();
    const statisticTitle: string = 'Количество пользователей';
    const list = ref([]);

    onMounted(async () => {
      // list.value = await getUserList();
      // appStore.setUserPublicList(list.value);
      await appStore.setMainSsrLoad(false);
    });

    return { userList, isMobile, statisticTitle, isSsr };
  },
});
